/**
 * Returns true if the user's device ia a Mac (macOS).
 */
export function isMacOS() {
  return typeof navigator !== 'undefined' && /macintosh|mac os x/i.test(navigator.userAgent)
}
